import React from "react";
import { ArticleList } from "@/components/ArticleList";

export default function Research() {
  return (
    <ArticleList
      type="research"
      region="global"
      label="Institutional-Grade"
      title="Research & Theses"
      subtitle="Deep-dive research, market briefs and the daily Lyfe Brief. Evidence-backed, not momentum-driven."
    />
  );
}
